"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertAnalyticsAccess = exports.isDemoAnalyticsUser = void 0;
const root_1 = require("../../root");
function isDemoAnalyticsUser(context) {
    var _a;
    return !!((_a = context.user) === null || _a === void 0 ? void 0 : _a.featureFlags.includes(root_1.FeatureFlag.Analytics_Pages_Demo));
}
exports.isDemoAnalyticsUser = isDemoAnalyticsUser;
function assertAnalyticsAccess(context, feature) {
    var _a, _b;
    const hasAnalyticsDemo = !!((_a = context.user) === null || _a === void 0 ? void 0 : _a.featureFlags.includes(root_1.FeatureFlag.Analytics_Pages_Demo));
    const hasAnalyticsFeature = (_b = context.user) === null || _b === void 0 ? void 0 : _b.featureFlags.includes(feature);
    if (hasAnalyticsFeature)
        return feature;
    if (hasAnalyticsDemo)
        return root_1.FeatureFlag.Analytics_Pages_Demo;
    throw new Error(`backend|AccessDenied`);
}
exports.assertAnalyticsAccess = assertAnalyticsAccess;
